module.exports = __webpack_public_path__ + "static/media/D644JettStNW_2018-06-26_134.1beb17a6.jpg";